"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkAppStore = void 0;
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
exports.mkAppStore = (0, immutable_1.Record)({
    sessionStartedAt: luxon_1.DateTime.utc().toISO(),
    storeCreatedAt: luxon_1.DateTime.utc().toISO(),
    isOffline: false,
    serviceWorkerIsRegistered: false,
    serviceWorkerIsRegistering: false,
    serviceWorkerUpdateIsAvailable: false,
    awaitingToAutoRefresh: false,
    updateAllFailed: undefined,
    updateAllMessages: undefined,
    isSanitized: undefined,
    csvImportCompleteByClientId: (0, immutable_1.Map)(),
    csvImportErrorByClientId: (0, immutable_1.Map)(),
    dbUpdateTrigger: undefined,
    fetchInProgress: undefined,
});
